import { connect } from 'react-redux';
import UiExperimentsPageComponent from '../components/ui-experiments/UiExperimentsPage';

const mapStateToProps = (state) => ({
  userId: state.catalogReducer?.user?.userId,
});

export default connect(mapStateToProps)(UiExperimentsPageComponent);
